export const styles = theme => ({

  // color
  valuePer: {
    fontSize: '3.5rem',
    fontWeight: 500,
    fontFamily: theme.typography.fontKanit,
  },
  value: {
    fontSize: '4rem',
    fontWeight: 500,
    fontFamily: theme.typography.fontKanit,
    lineHeight: '100%',
  },
  statusText: {
    borderRadius: 5,
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
    fontFamily: theme.typography.fontKanit,
    fontSize: 12,
  },
  table: {
    maxWidth: 250,
  },
  hiddenLine: {
    borderBottom: 0,
    fontSize: '12px',
  },
  boxContent: {
    border: '1px solid #ccc',
  },
  lable: {
    fontSize: '18px',
    fontFamily: theme.typography.fontKanit,
  },
  unit: {
    fontSize: '16px',
    fontFamily: theme.typography.fontKanit,
  },
  dateTime: {
    fontFamily: theme.typography.fontKanit,
    fontSize: '10px',
    color: '#777',
  },

  //color

  one: {
    color: '#FFC100',
    constrastColor: '#000',
  },
  two: {
    background: '#00B050',
    constrastColor: '#000',
  },
  three: {
    background: '#003CFA',
    constrastColor: '#fff',
  },
  four: {
    color: '#fff',
    background: '#FF0000',
    constrastColor: '#fff',
  },
  five: {
    color: '#fff',
    background: '#C70200',
    constrastColor: '#fff',
  },
});